export default {
    getterPaginationData: ({ paginationData }) => {
        const { pageNumber, pages } = paginationData;
        return {
            pageNumber,
            pages,
        };
    },
    getterPageSize: ({ filterOption }) => filterOption.pageSize,
    getterPaymentDetailList: ({ list }) => list ?? [],
};
